import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f35a402&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f35a402",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/DiTuYouXuan/DiTuAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f35a402')) {
      api.createRecord('2f35a402', component.options)
    } else {
      api.reload('2f35a402', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2f35a402&scoped=true&", function () {
      api.rerender('2f35a402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/systemCreator/systemConfig/levelConfig/index.vue"
export default component.exports